import React from 'react';
import { 
	func,
	array
} from 'prop-types';
import Presenter from './Presenter';
import Container from './Container';

const InputChip = ({tags,onEnter,onRemove,...props}) => 
	<Container 
		tags={tags}
		onEnter={onEnter}
		onRemove={onRemove}
		render={({...containerProps})=>
			<Presenter 
				onRemove={onRemove}
				{...containerProps}
				{...props}
			/>}/>;

InputChip.propTypes = {
	tags : array,
	onEnter : func,
	onRemove : func,
};

export default InputChip;